import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './About.styles';

const About = (props) => {
  const { version, client } = props;
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <div>
        <span>Version </span>
        {version}
      </div>
      <div>
        <span>Licensed to </span>
        {client}
      </div>
    </div>
  );
};
export default About;

About.propTypes = {
  version: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired
};
